import { Wrench, Cable, Zap, Shield, Clock, Building2 } from "lucide-react";

const REPAIR_IMG =
  "https://static.prod-images.emergentagent.com/jobs/8556163b-a21a-4889-85bf-57bee7a466d6/images/b24fe5e4a06fbd0bf91767ba9c911ea4f16fd81d762d2fc9e67928c11065581f.png";
const CONSTRUCTION_IMG =
  "https://static.prod-images.emergentagent.com/jobs/8556163b-a21a-4889-85bf-57bee7a466d6/images/6bfa0d4d4856d94bc939edc8fcea720222115c33fe5497df645e1ff5266684af.png";

const SUB_SERVICES = [
  {
    icon: Zap,
    title: "Άμεση επέμβαση",
    desc: "Διάγνωση και αποκατάσταση βλάβης σε ελάχιστο χρόνο.",
  },
  {
    icon: Shield,
    title: "Πιστοποιημένη ποιότητα",
    desc: "Εξειδικευμένα τεχνικά συνεργεία και βιομηχανικός εξοπλισμός.",
  },
  {
    icon: Clock,
    title: "Συντήρηση δικτύου",
    desc: "Προληπτικοί έλεγχοι και μετρήσεις OTDR στο πεδίο.",
  },
  {
    icon: Building2,
    title: "Εντός εγκαταστάσεων",
    desc: "Καλωδιώσεις και τερματισμοί σε γραφεία, data centers, ξενοδοχεία.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-6 items-end mb-16">
          <div className="col-span-12 lg:col-span-7">
            <div className="overline mb-4">01 / Υπηρεσίες</div>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white">
              Από τη βλάβη στο πεδίο,
              <br />
              στο πλήρες έργο υποδομής.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5">
            <p className="text-[#A1A1AA] text-base sm:text-lg leading-relaxed">
              Καλύπτουμε όλο τον κύκλο ζωής μιας υποδομής οπτικών ινών — από
              την κατασκευή και τον τερματισμό, έως την πιστοποίηση και την
              αποκατάσταση βλαβών.
            </p>
          </div>
        </div>

        {/* Two main service cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-[#27272A]">
          <ServiceCard
            tag="01"
            title="Αποκατάσταση Βλαβών"
            description="Άμεση και υπεύθυνη επέμβαση για την αποκατάσταση βλαβών σε δίκτυα οπτικών ινών. Διαθέτουμε εξοπλισμό fusion splicing και OTDR για διάγνωση μήκους βλάβης, ελαχιστοποιώντας τον χρόνο διακοπής."
            image={REPAIR_IMG}
            icon={Wrench}
            testid="service-repair"
          />
          <ServiceCard
            tag="02"
            title="Κατασκευές Εντός & Εκτός"
            description="Υλοποίηση έργων υποδομής οπτικών ινών σε εξωτερικούς χώρους — αστικά δίκτυα, εναέριες & υπόγειες οδεύσεις — αλλά και εντός εγκαταστάσεων του πελάτη με πιστοποιημένους τερματισμούς."
            image={CONSTRUCTION_IMG}
            icon={Cable}
            testid="service-construction"
          />
        </div>

        {/* Sub-services grid */}
        <div className="mt-px grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#27272A]">
          {SUB_SERVICES.map((s) => (
            <div
              key={s.title}
              className="bg-[#0F0F11] p-6 lg:p-8 hover:bg-[#16161A] transition-colors"
              data-testid={`subservice-${s.title.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <s.icon
                size={28}
                strokeWidth={1.5}
                className="text-[#E63946] mb-5"
              />
              <h3 className="font-heading text-lg text-white mb-2 font-medium">
                {s.title}
              </h3>
              <p className="text-sm text-[#A1A1AA] leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ tag, title, description, image, icon: Icon, testid }) {
  return (
    <article
      data-testid={testid}
      className="group relative bg-[#0F0F11] overflow-hidden"
    >
      <div className="aspect-[16/10] overflow-hidden border-b border-[#27272A]">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-8 lg:p-10">
        <div className="flex items-center justify-between mb-5">
          <span className="font-mono-th text-xs tracking-[0.25em] text-[#E63946]">
            {tag} / SERVICE
          </span>
          <Icon size={22} strokeWidth={1.5} className="text-white/80" />
        </div>
        <h3 className="font-heading text-2xl sm:text-3xl text-white mb-4 font-medium tracking-tight">
          {title}
        </h3>
        <p className="text-[#A1A1AA] leading-relaxed">{description}</p>
      </div>
    </article>
  );
}
